import React, { Component } from 'react';
import { Facebook, Instagram, Ship } from 'lucide-react';
export const Footer: React.FC = () => {
  const handleWhatsAppClick = (message: string = '') => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/50256284598?text=${encodedMessage}`, '_blank');
  };
  return <footer className="bg-wood-texture bg-cover bg-center relative py-12 px-4" data-id="element-38">
      <div className="absolute inset-0 bg-pirate-black opacity-90" data-id="element-39"></div>
      <div className="container mx-auto relative z-10" data-id="element-40">
        <div className="flex flex-col items-center mb-8" data-id="element-41">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eFa5T1mpwhzi4xKfC4a9AH/LOGO_PERLA_NEGRA.png" alt="Perla Negra Logo" className="h-24 mb-6" data-id="element-42" />
          <p className="font-pirata text-xl md:text-2xl text-center max-w-2xl" data-id="element-43">
            Perla Negra – Donde los piratas del sabor gobiernan los mares de la
            carne Angus.
          </p>
        </div>
        <div className="flex justify-center space-x-6 mb-8" data-id="element-44">
          <a href="#" className="text-pirate-red hover:text-white transition-colors" aria-label="Facebook" data-id="element-45">
            <Facebook size={28} data-id="element-46" />
          </a>
          <a href="#" className="text-pirate-red hover:text-white transition-colors" aria-label="Instagram" data-id="element-47">
            <Instagram size={28} data-id="element-48" />
          </a>
          <a href="#" className="text-pirate-red hover:text-white transition-colors" aria-label="TikTok" data-id="element-49">
            <Ship size={28} data-id="element-50" />
          </a>
        </div>
        <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-8" data-id="element-51">
          <button onClick={() => {}} className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-52">
            Ver Menú
          </button>
          <button onClick={() => handleWhatsAppClick('Hola Perla Negra, me gustaría reservar una mesa para...')} className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-53">
            Reservar Mesa
          </button>
          <button onClick={() => handleWhatsAppClick('Hola Perla Negra, me gustaría solicitar información sobre eventos privados...')} className="font-pirata text-lg hover:text-pirate-red transition-colors" data-id="element-54">
            Eventos Privados
          </button>
        </div>
        <div className="mt-10 text-center text-sm text-gray-400" data-id="element-55">
          <p data-id="element-56">
            © {new Date().getFullYear()} Restaurante Perla Negra – Angus Beef
            House & Pirate Experience
          </p>
        </div>
      </div>
    </footer>;
};